import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { CompanyUserService } from '@treasury/domain/company/user';
import { CompanyUserAchEntitlements } from '@treasury/domain/company/user/entities/entitlements';
import { CompanyUserAchLimits } from '@treasury/domain/company/user/entities/limits';
import { TmBaseComponent } from '@treasury/presentation';
import { TmToastPosture, TmToastService } from '@treasury/presentation/services/toast';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import '../limits-and-entitlements/limits-and-entitlements.component';

@customElement('tm-bo-limits-and-entitlements-ach')
export class AchLimitsAndEntitlements extends TmBaseComponent {
    @InjectProperty()
    declare private readonly companyUserService: CompanyUserService;

    @InjectProperty()
    declare private readonly toastService: TmToastService;

    @property()
    declare private readonly companyId: number;

    @property()
    declare private readonly userId: number;

    @state()
    declare private limits: CompanyUserAchLimits;

    @state()
    declare private entitlements: CompanyUserAchEntitlements;

    @state()
    private loading = true;

    public render() {
        if (this.loading) {
            return html`<jha-progress></jha-progress> Loading ACH limits and entitlements...`;
        }
        return html`<div class="flex flex-col gap-10">${this.renderLimitsAndEntitlements()}</div>`;
    }

    protected async firstUpdated() {
        try {
            this.loading = true;
            this.limits = await this.companyUserService.getCompanyUserAchLimits(
                this.userId,
                this.companyId
            );
            this.entitlements = await this.companyUserService.getCompanyUserAchEntitlements(
                this.userId,
                this.companyId
            );
        } catch {
            this.toastService.show(
                'Error fetching ACH limits and entitlements',
                TmToastPosture.Danger,
                true
            );
        } finally {
            this.loading = false;
        }
    }

    private renderLimitsAndEntitlements() {
        return html`<tm-company-user-limits-and-entitlements-common
            .companyId=${this.companyId}
            .userId=${this.userId}
            .limits=${this.limits}
            .entitlements=${this.entitlements}
        ></tm-company-user-limits-and-entitlements-common>`;
    }
}
